import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Bot, Currency, CustomGridOrder, Direction, GridType, Ticker } from "../../_app/types";
import { INIT_STATE_BOT } from "../../_app/consts";

// Начальное состояние
const initialState: Bot = INIT_STATE_BOT;

const botSlice = createSlice({
  name: "bot",
  initialState,
  reducers: {
    setDirection: (state, action: PayloadAction<Direction>) => {
      state.gridDirection = action.payload;
    },
    setInvestment: (state, action: PayloadAction<number>) => {
      state.investment = action.payload;
    },
    setLeverage: (state, action: PayloadAction<number>) => {
      state.leverage = action.payload;
    },
    setBase: (state, action: PayloadAction<string>) => {
      state.base = action.payload;
    },
    setQuote: (state, action: PayloadAction<string>) => {
      state.quote = action.payload;
    },
    setMinPrice: (state, action: PayloadAction<number>) => {
      state.minPrice = action.payload;
    },
    setMaxPrice: (state, action: PayloadAction<number>) => {
      state.maxPrice = action.payload;
    },
    setCustomLowPrice: (state, action: PayloadAction<number>) => {
      state.customLowPrice = action.payload;
    },
    setCustomHighPrice: (state, action: PayloadAction<number>) => {
      state.customHighPrice = action.payload;
    },
    setPriceStep: (state, action: PayloadAction<number>) => {
      state.priceStep = action.payload;
    },
    setStartPrice: (state, action: PayloadAction<number>) => {
      state.startPrice = action.payload;
    },
    setCurrencyType: (state, action: PayloadAction<Currency>) => {
      state.currencyType = action.payload;
    },
    setGridType: (state, action: PayloadAction<GridType>) => {
      state.gridType = action.payload;
    },
    setGridsAmount: (state, action: PayloadAction<number>) => {
      state.gridsAmount = action.payload;
    },
    setTicker: (state, action: PayloadAction<Ticker>) => {
      state.ticker = action.payload;
    },
    setPriceStepQuote: (state, action: PayloadAction<number>) => {
      state.priceStepQuote = action.payload;
    },
    setPriceStepPercentage: (state, action: PayloadAction<string>) => {
      state.priceStepPercentage = action.payload;
    },
    setStepsCount: (state, action: PayloadAction<number>) => {
      state.stepsCount = action.payload;
    },
    setCustomGridSettings: (state, action: PayloadAction<CustomGridOrder[]>) => {
      state.customGridSettings = action.payload;
    },
    clearBotState: (state) => {
      Object.assign(state, INIT_STATE_BOT);
    },
    setOrderSize: (state, action: PayloadAction<number>) => {
      state.orderAmount = action.payload;
    },
  },
});

// Экспортируем экшен
export const {
  setDirection,
  setInvestment,
  setLeverage,
  setBase,
  setMaxPrice,
  setMinPrice,
  setPriceStep,
  setStartPrice,
  setCurrencyType,
  setGridsAmount,
  setGridType,
  setTicker,
  setPriceStepPercentage,
  setPriceStepQuote,
  setStepsCount,
  setQuote,
  setCustomGridSettings,
  clearBotState,
  setCustomLowPrice,
  setCustomHighPrice,
  setOrderSize
} = botSlice.actions;

// Экспортируем редьюсер
export default botSlice.reducer;
